import plainAxios from 'axios';
import type { AxiosProgressEvent } from 'axios';
import { S3_UPLOAD_TIMEOUT_MS } from '../constants/whatsapp';

export function uploadToS3(
  uploadUrl: string,
  uploadFields: Record<string, string>,
  file: File,
  onUploadProgress: (event: AxiosProgressEvent) => void,
) {
  const s3Form = new FormData();
  Object.entries(uploadFields).forEach(([name, value]) =>
    s3Form.append(name, value),
  );
  s3Form.append('file', file);

  return plainAxios.post(uploadUrl, s3Form, {
    timeout: S3_UPLOAD_TIMEOUT_MS,
    onUploadProgress,
  });
}
